export default "__VITE_ASSET__C6I9na2d__"